<template>
  <div class="col-lg-4 theiaStickySidebar">
    <div class="stickysidebar">
      <div class="review-sec mt-0">
        <div class="review-header">
          <h4>السعر</h4>
        </div>
        <div class="mb-3">
          <div
            v-if="carDetails?.car?.rent_or_sale == 'sale'"
            class="payment-option"
          >
            <span class="title">كاش</span>
            <span class="price">${{ carDetails?.car?.price }}</span>
          </div>
          <div v-else-if="carDetails?.car?.rent_or_sale == 'rent'">
            <div style="margin-bottom: 1rem">
              <span class="price">ايجار</span>
            </div>
            <div class="payment-option">
              <span class="title">سعر الايجار اليومى</span>
              <span class="price">${{ carDetails?.car?.price?.daily }}</span>
            </div>
            <div class="payment-option">
              <span class="title">سعر الايجار الاسبوعى</span>
              <span class="price">${{ carDetails?.car?.price?.weekly }}</span>
            </div>
            <div class="payment-option">
              <span class="title">سعر الايجار الشهرى</span>
              <span class="price">${{ carDetails?.car?.price?.monthly }}</span>
            </div>
          </div>

          <div v-else>
            <div style="margin-bottom: 1rem">
              <span class="price">تقسيط</span>
            </div>
            <div class="payment-option">
              <span class="title">السعر</span>

              <span class="price"
                >${{ carDetails?.car?.installment?.price }}</span
              >
            </div>
            <div class="payment-option">
              <span class="title">سعر القسط شهريا</span>

              <span class="price"
                >${{ carDetails?.car?.installment?.monthly }}</span
              >
            </div>
            <div class="payment-option">
              <span class="title">عدد الاقساط</span>

              <span class="price">{{
                carDetails?.car?.installment?.duration_months
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="review-sec extra-service mt-0">
        <div class="review-header">
          <h4>تفاصيل مالك الإعلان</h4>
        </div>

        <div class="owner-detail">
          <div class="owner-img">
            <a href="#">
              <img
                :src="
                  carDetails?.car?.user?.image ||
                  require('@/assets/img/profiles/avatar-07.jpg')
                "
                alt="User"
              />
            </a>
            <span class="badge-check">
              <img src="@/assets/img/icons/badge-check.svg" alt="Verified" />
            </span>
          </div>

          <div class="reviewbox-list-rating">
            <h5>
              <a>{{ carDetails?.car?.user?.name || "غير معروف" }}</a>
            </h5>
            <!-- <p>
              <i v-for="i in 5" :key="i" class="fas fa-star filled"></i>
              <span>({{ carDetails?.car?.user?.rating || "5.0" }})</span>
            </p> -->
          </div>
        </div>

        <ul class="booking-list">
          <li>
            البريد الإلكتروني
            <span>{{ carDetails?.car?.user?.email || "غير متوفر" }}</span>
          </li>
          <li>
            رقم الهاتف
            <span>{{ carDetails?.car?.phone || "غير متوفر" }}</span>
          </li>
          <li>
            الموقع
            <span
              >{{ carDetails?.car?.city.name }} -
              {{ carDetails?.car?.district.name }}</span
            >
          </li>
          <li>
            تاريخ الإنشاء
            <span>
              {{
                new Date(carDetails?.car?.created_at).toLocaleDateString(
                  "ar-EG",
                  {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  }
                )
              }} ({{ timeAgo(carDetails?.car?.created_at) }})
            </span>
          </li>
        </ul>

        <div class="message-btn">
          <a href="#" class="btn btn-order">إرسال رسالة للمالك</a>

          <a
            :href="`https://wa.me/${carDetails?.car?.whatsapp.replace(
              /\D/g,
              ''
            )}`"
            target="_blank"
            class="chat-link"
          >
            <i class="fab fa-whatsapp fi-icon small-icon"></i>
            الدردشة عبر واتساب
          </a>
        </div>
      </div>

      <!-- <div class="review-sec share-car mt-0">
        <div class="review-header">
          <h4>View Car Location</h4>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509170.989457427!2d-123.80081967108484!3d37.192957227641294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1669181581381!5m2!1sen!2sin"
          class="iframe-video"
        ></iframe>
      </div> -->
      <div class="review-sec share-car mt-0 mb-0">
        <div class="review-header">
          <h4>شارك</h4>
        </div>
        <ul class="nav-social">
          <li>
            <a :href="shareLinks.facebook" target="_blank" rel="noopener">
              <i class="fa-brands fa-facebook-f fa-facebook fi-icon"></i>
            </a>
          </li>
          <li>
            <a :href="shareLinks.instagram" target="_blank" rel="noopener">
              <i class="fab fa-instagram fi-icon"></i>
            </a>
          </li>
          <li>
            <a :href="shareLinks.behance" target="_blank" rel="noopener">
              <i class="fab fa-behance fi-icon"></i>
            </a>
          </li>
          <li>
            <a :href="shareLinks.pinterest" target="_blank" rel="noopener">
              <i class="fa-brands fa-pinterest-p fi-icon"></i>
            </a>
          </li>
          <li>
            <a :href="shareLinks.twitter" target="_blank" rel="noopener">
              <i class="fab fa-twitter fi-icon"></i>
            </a>
          </li>
          <li>
            <a :href="shareLinks.linkedin" target="_blank" rel="noopener">
              <i class="fab fa-linkedin fi-icon"></i>
            </a>
          </li>
          <li>
            <a :href="shareLinks.whatsapp" target="_blank" rel="noopener">
              <i class="fab fa-whatsapp fi-icon"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
const currentDateTwo = ref(new Date());
const currentDateThree = ref(new Date());
export default {
  props: {
    carDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      shareLinks: {},

      startdate: currentDate,
      startdateOne: currentDateOne,
      startdateTwo: currentDateTwo,
      startdateThree: currentDateThree,
      dateFormat: "dd-MM-yyyy",
      NewDelivery: [
        "Newyork Office - 78, 10th street Laplace USA",
        "Newyork Office - 12, 5th street USA",
      ],
      NewLocation: [
        "Newyork Office - 78, 10th street Laplace USA",
        "Newyork Office - 12, 5th street USA",
      ],
    };
  },
  mounted() {
    const currentUrl = encodeURIComponent(window.location.href);
    const text = encodeURIComponent("Check this out!");

    this.shareLinks = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
      instagram: `https://www.instagram.com/?url=${currentUrl}`,
      behance: `https://www.behance.net/`,
      pinterest: `https://pinterest.com/pin/create/button/?url=${currentUrl}&description=${text}`,
      twitter: `https://twitter.com/intent/tweet?url=${currentUrl}&text=${text}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`,
      whatsapp: `https://wa.me/?text=${text}%20${currentUrl}`,
    };
  },
  methods: {
    timeAgo(date) {
      if (!date) return "";
      const now = new Date();
      const created = new Date(date);
      const diff = Math.floor((now - created) / 1000);

      if (diff < 60) return "منذ ثوانٍ";
      if (diff < 3600) return `منذ ${Math.floor(diff / 60)} دقيقة`;
      if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} ساعة`;
      if (diff < 2592000) return `منذ ${Math.floor(diff / 86400)} يوم`;
      if (diff < 31104000) return `منذ ${Math.floor(diff / 2592000)} شهر`;
      return `منذ ${Math.floor(diff / 31104000)} سنة`;
    },
  },
};
</script>
<style scoped>
.small-icon {
  min-width: 20px;
  height: 20px;
  margin: 0 5px;
}
.payment-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #ddd; /* optional for styling */
  border-radius: 6px; /* optional */
  background: #fff; /* match your theme */
  margin-bottom: 10px; /* space between rows */
}

.payment-option .title {
  font-size: 16px;
  font-weight: 500;
}

.payment-option .price,
.price {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
</style>
